<template lang="html">
  <b-navbar toggleable="lg" type="dark" variant="secondary">
    <b-navbar-brand :to="{ name: 'home' }">Soundslides Manager</b-navbar-brand>

    <b-navbar-toggle target="nav-collapse" />

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav v-show="$store.state.authorized">
        <b-nav-item :to="{ name: 'groups' }">My Groups</b-nav-item>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <!--
        If you're going to add a search bar, do it here.
        <b-nav-form>
          <b-form-input size="sm" class="mr-sm-2" placeholder="Search"></b-form-input>
          <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
        </b-nav-form>
      -->

        <b-navbar-nav v-if="authorized" right>
          <b-nav-item @click="$store.dispatch('sign_out')">Logout</b-nav-item>
        </b-navbar-nav>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  computed: {
    authorized() {
      return this.$store.state.authorized;
    },
    is_trial() {
      return this.$store.getters.is_trial;
    },
    conversion_route() {
      if (this.authorized) {
        return { name: "converter" };
      } else {
        return { name: "trial" };
      }
    },
    hosting_conversion_route() {
      if (this.authorized) {
        return { name: "hosting" };
      } else {
        return { name: "trial" };
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
